import variationsFor from './variationsFor'

const types = {
  ...variationsFor('GET_ORGANISATION')
}

export default types
